<template>
  <div class="strangerPage" :style="customStyle">
    <div class="stranger">
      <!-- 头部 -->
      <div class="headArea gray-10-bd">
        <div class="left">
          <!-- 头像 -->
          <div class="avataAndName">
            <div class="avatar blue-bg white-cl">
              <div v-if="imageUrl">
                <img :src="imageUrl" alt="" />
              </div>
              <div v-else-if="name">{{ name }}</div>
              <div class="lineIcon" :class="loginStatus === 1 ? 'green-bg' : 'gray-bg'"></div>
            </div>
            <!-- 名称/在线状态 -->
            <div class="otcTrade-user">
              <div class="otcTrade-userName main-cl" :title="otcNickName">
                {{ otcNickName }}
                <!-- <span v-html="userVip" style="margin-left: 2px"></span> -->
              </div>
              <div class="otcTrade-userStatus" :class="loginStatus === 1 ? 'green-cl' : 'gray-cl'">
                {{ loginStatus === 1 ? $t("stranger.online") : $t("stranger.offline") }}
              </div>
            </div>
            <c-button
              v-show="blackList !== 0"
              className="b-4-cl blackListButton"
              type="text"
              height="26px"
              @click="blackClick"
            >
              {{
                blackList === 0
                  ? ""
                  : blackList === 2
                  ? $t("stranger.addBlackList")
                  : $t("stranger.removeBlackList")
              }}
            </c-button>
          </div>
          <!-- 交易次数 -->
          <div class="header-even">
            <div class="header-even-value gray-cl">{{ $t("stranger.headerList")[0] }}</div>
            <div class="header-even-key main-cl">{{ completeOrders }}</div>
          </div>
          <!-- 总申诉量 -->
          <div class="header-even">
            <div class="header-even-value gray-cl">{{ $t("stranger.headerList")[1] }}</div>
            <div class="header-even-key main-cl">{{ complainNum }}</div>
          </div>
          <!-- 胜诉率 -->
          <div class="header-even">
            <div class="header-even-value gray-cl">{{ $t("stranger.headerList")[2] }}</div>
            <div class="header-even-key main-cl">{{ sucComplainNum }}</div>
          </div>
        </div>
        <div class="right">
          <div class="certificateItem">
            <svg-icon
              style="font-size: 20px"
              :class="mobileAuthStatus === 1 ? 'blue-cl' : 'gray-cl'"
              icon-class="icon-auth"
            ></svg-icon>
            <span
              >{{ $t("stranger.phone")
              }}{{ mobileAuthStatus === 1 ? $t("stranger.already") : $t("stranger.never")
              }}{{ $t("stranger.certification") }}</span
            >
          </div>
          <div class="certificateItem">
            <svg-icon
              style="font-size: 20px"
              :class="authLevel === 1 ? 'blue-cl' : 'gray-cl'"
              icon-class="icon-auth"
            ></svg-icon>
            <span
              >{{ $t("stranger.identity")
              }}{{ authLevel === 1 ? $t("stranger.already") : $t("stranger.never")
              }}{{ $t("stranger.certification") }}</span
            >
          </div>
        </div>
      </div>
      <div class="stranger-center clearfix a-5-bg">
        <div class="strangerbar">
          <div class="nav-tab clearfix a-3-bd">
            <c-navTab
              activeClassName="b-1-cl"
              activeColor="a-12-bg"
              className="b-2-cl"
              :currentTab="currentTab"
              :navTab="navTab"
              :lineHeight="lineHeight"
              :marginRight="marginRight"
              @currentType="currentType"
            />
          </div>
          <div class="tables clearfix">
            <c-table
              :loading="loading"
              :imgMap="imgMap"
              :colorMap="colorMap"
              :classes="classes"
              :headClasses="headClasses"
              :bodyClasses="bodyClasses"
              :lineClasses="lineClass"
              :columns="columns"
              :dataList="dataList"
              :lineNumber="lineNumber"
              :cellHeight="cellHeight"
              :headHeight="headHeight"
              @elementClick="operation"
            />
            <c-pagination
              v-show="count > 10"
              :total="count"
              :current-page="page"
              :display="pageSize"
              classes="a-5-bg"
              @pagechange="pagechange"
            >
            </c-pagination>
          </div>
        </div>
      </div>
      <c-dialog
        :showFlag="dialogFlag"
        paddingBottom="14px"
        :confirmLoading="dialogConfirmLoading"
        :confirmDisabled="dialogConfirmDisabled"
        @close="dialogClose"
        @confirm="dialogConfirm"
        :titleText="$t('personal.dialog.blackPrompt')"
      >
        <p class="dialog-p">
          {{
            blackList === 2 ? $t("stranger.blackListPrompt")[0] : $t("stranger.blackListPrompt")[1]
          }}
        </p>
      </c-dialog>
    </div>
  </div>
</template>

<script>
import {
  fixD, imgMap, colorMap, getCoinShowName,
} from '@/utils';

export default {
  name: 'stronger',
  props: {
    propUid: {
      type: [String, Number],
      default: '',
    },
    customStyle: {
      type: String,
      default: 'width: 100%',
    },
  },
  data() {
    return {
      imgMap,
      colorMap,
      loading: false,
      side: 'SELL',
      identity: 0, // 0 为拉黑， 1 被拉黑
      // 弹框
      dialogFlag: false,
      dialogConfirmLoading: false,
      dialogConfirmDisabled: false,
      blackList: 0, // 0 用户本人或未登录， 1 被拉黑， 2 未被拉黑
      uid: this.$route.query.uid || this.propUid,
      name: '',
      loginStatus: 0, // 在线状态 (1在线，0离线)
      imageUrl: '',
      otcNickName: '',
      completeOrders: '',
      complainNum: '',
      sucComplainNum: '',
      authLevel: '', // 认证状态 0、未审核，1、通过，2、未通过  3、未认证
      mobileAuthStatus: '', // 是否开启了手机认证:0-未开启,1-开启
      // 横向导航参数
      currentTab: 1,
      navTab: [
        {
          name: this.$t('stranger.navTab')[0],
          index: 1,
        },
        {
          name: this.$t('stranger.navTab')[1],
          index: 2,
        },
      ],
      lineHeight: '55',
      marginRight: 48, // 距离右边的距离
      // table 相关
      columns: [
        {
          title: this.$t('stranger.columns')[0],
          align: 'left',
          width: '100px',
          classes: '',
        },
        {
          title: this.$t('stranger.columns')[1],
          align: 'left',
          width: '100px',
          classes: '',
        },
        {
          title: this.$t('stranger.columns')[2],
          align: 'left',
          width: '200px',
          classes: '',
        },
        {
          title: this.$t('stranger.columns')[3],
          align: 'left',
          width: '200px',
          classes: '',
        },
        {
          title: this.$t('stranger.columns')[4],
          align: 'left',
          width: '200px',
          classes: '',
        },
        {
          title: this.$t('stranger.columns')[5],
          align: 'left',
          width: '100px',
          classes: '',
        },
      ],
      dataList: [],
      cellHeight: 55,
      headHeight: 48,
      lineNumber: 10,
      classes: '',
      headClasses: '',
      bodyClasses: '',
      lineClass: '',
      // page相关
      count: 0,
      page: 1,
      pageSize: 10,
    };
  },
  computed: {
    otcPersonHomePage() {
      return this.$store.state.fiatdeal.otcPersonHomePage;
    },
    otcPersonAds() {
      return this.$store.state.personal.otcPersonAds;
    },
    otcUserContacts() {
      return this.$store.state.fiatdeal.otcUserContacts;
    },
    otcUserContactsRemove() {
      return this.$store.state.fiatdeal.otcUserContactsRemove;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
  },
  watch: {
    otcPersonHomePage(otcPersonHomePage) {
      if (otcPersonHomePage !== null) {
        this.name = otcPersonHomePage.data.otcNickName.substring(0, 1);
        this.otcNickName = otcPersonHomePage.data.otcNickName;
        this.loginStatus = otcPersonHomePage.data.loginStatus;
        this.imageUrl = otcPersonHomePage.data.imageUrl;
        this.completeOrders = otcPersonHomePage.data.completeOrders;
        this.complainNum = otcPersonHomePage.data.complainNum;
        this.sucComplainNum = otcPersonHomePage.data.sucComplainNum;
        this.authLevel = otcPersonHomePage.data.authLevel;
        this.mobileAuthStatus = otcPersonHomePage.data.mobileAuthStatus;
        this.blackList = otcPersonHomePage.data.identity;
      }
    },
    otcUserContactsRemove(otcUserContactsRemove) {
      if (otcUserContactsRemove !== null) {
        if (otcUserContactsRemove.text === 'success') {
          this.$bus.$emit('tip', { text: otcUserContactsRemove.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.$store.dispatch('otcPersonHomePage', { uid: this.uid });
          this.dialogFlag = false;
        } else {
          this.$bus.$emit('tip', { text: otcUserContactsRemove.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    otcPersonAds(otcPersonAds) {
      if (otcPersonAds !== null) {
        if (this.publicInfo) {
          this.loading = false;
          // 数据处理
          this.dataProcessin(otcPersonAds.data, this.$store.state.baseData.market);
        }
      }
    },
    otcUserContacts(otcUserContacts) {
      if (otcUserContacts !== null) {
        if (otcUserContacts.text === 'success') {
          this.$bus.$emit('tip', { text: otcUserContacts.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.$store.dispatch('otcPersonHomePage', { uid: this.uid });
          this.dialogFlag = false;
        } else {
          this.$bus.$emit('tip', { text: otcUserContacts.msg, type: 'error' });
          this.$store.dispatch('resetType');
          this.$bus.$emit('getCode-clear', 'phone');
        }
      }
    },
    propUid() {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch('otcPersonHomePage', { uid: this.uid });
      const info = {
        uid: this.uid,
        page: this.page,
        pageSize: this.pageSize,
        adType: 'BUY',
      };
      this.$store.dispatch('otcPersonAds', info);
      this.loading = true;
      const infoData = { relationType: 'BLACKLIST', pageSize: 10000, page: 1 };
      this.$store.dispatch('otcPersonRelationship', infoData);
    },
    dataProcessin(data, market) {
      this.count = data.count;
      const list = [];
      data.adList.forEach((obj) => {
        list.push({
          id: [this.uid, obj.advertId],
          data: [
            getCoinShowName(obj.coin, market.coinList),
            fixD(obj.volume, market.coinList[obj.coin].showPrecision),
            `${fixD(
              obj.minTrade,
              market.coinList[obj.coin].fiatPrecision[obj.payCoin.toLowerCase()]
                ? Number(market.coinList[obj.coin].fiatPrecision[obj.payCoin.toLowerCase()])
                : this.$store.state.baseData.defaultFiatPrecision,
            )} -
              ${fixD(
    obj.maxTrade,
    market.coinList[obj.coin].fiatPrecision[obj.payCoin.toLowerCase()]
      ? Number(market.coinList[obj.coin].fiatPrecision[obj.payCoin.toLowerCase()])
      : this.$store.state.baseData.defaultFiatPrecision,
  )} ${obj.payCoin}`,
            fixD(
              obj.price,
              market.coinList[obj.coin].fiatPrecision[obj.payCoin.toLowerCase()]
                ? Number(market.coinList[obj.coin].fiatPrecision[obj.payCoin.toLowerCase()])
                : this.$store.state.baseData.defaultFiatPrecision,
            ) + obj.payCoin,
            [
              {
                type: 'icon',
                iconSvg: `<ul>
                    ${this.paymentsList(obj.payments).join('')}
                </ul>`,
                classes: 'payments-ul',
              },
            ],
            [
              {
                type: 'button', // 'link' ' button' ,'html', 'label', 'icon' ‘str’
                attrs: {
                  type: 'solid',
                  height: '32px',
                },
                text: this.textShow(obj.side),
                iconClass: [''],
                eventType: 'close',
                classes: [''],
              },
            ],
          ],
        });
      });
      console.log('list', list);
      this.dataList = list;
    },
    textShow(side) {
      let text = '';
      // if (this.blackList === 0) {
      //   text = this.$t('stranger.view');
      // } else {
      text = side === 'SELL' ? this.$t('stranger.buy') : this.$t('stranger.sell');
      // }
      return text;
    },
    paymentsList(data) {
      const list = [];
      data.forEach((obj) => {
        list.push(`<li class=''><img src="${obj.icon}"/></li>`);
      });
      return list;
    },
    blackClick() {
      this.dialogFlag = true;
    },
    dialogClose() {
      this.dialogFlag = false;
    },
    dialogConfirm() {
      if (this.blackList === 1) {
        // 移除
        const info = { friendId: this.uid };
        this.$store.dispatch('otcUserContactsRemove', info);
      } else {
        // 加入黑名单
        const info = { otherUid: this.uid, relationType: 'BLACKLIST' };
        this.$store.dispatch('otcUserContacts', info);
      }
    },
    currentType(data) {
      this.loading = true;
      this.currentTab = data.index;
      this.page = 1;
      if (this.currentTab === 1) {
        this.side = 'BUY';
        const info = {
          uid: this.uid,
          page: this.page,
          pageSize: this.pageSize,
          adType: 'BUY',
        };
        this.$store.dispatch('otcPersonAds', info);
      } else {
        this.side = 'SELL';
        const info = {
          uid: this.uid,
          page: this.page,
          pageSize: this.pageSize,
          adType: 'SELL',
        };
        this.$store.dispatch('otcPersonAds', info);
      }
    },
    operation(type, id) {
      if (type === 'close') {
        this.$router.push({ path: '/otcTrade?', query: { orderId: id[1], userId: id[0] } });
      }
    },
    pagechange(page) {
      this.page = page;
      const info = {
        uid: this.uid,
        page: this.page,
        pageSize: this.pageSize,
        adType: this.side,
      };
      this.$store.dispatch('otcPersonAds', info);
    },
  },
};
</script>

<style lang="scss">
.strangerPage {
  margin: 0 auto;
  .stranger {
    // min-height: 800px;
    margin: 0 auto;
    display: grid;

    .headArea {
      height: 96px;
      padding: 16px 24px;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .left {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 40px;

        .avataAndName {
          display: flex;
          align-items: center;
          gap: 8px;

          .avatar {
            display: inline-block;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            text-align: center;
            line-height: 30px;
            font-size: 14px;
            position: relative;
            vertical-align: middle;
            cursor: pointer;

            div {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              overflow: hidden;
            }

            img {
              width: 30px;
              height: 30px;
              display: block;
            }
            .lineIcon {
              position: absolute;
              width: 8px;
              height: 8px;
              right: 1px;
              bottom: 0px;
              border-radius: 50%;
            }
          }

          // 名称/在线状态
          .otcTrade-user {
            display: flex;
            flex-direction: column;

            .otcTrade-userName {
              font-size: 16px;
              height: 22px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              max-width: 100px;
            }

            .otcTrade-userStatus {
              margin-top: 4px;
              font-size: 12px;
            }
          }
        }

        .header-even {
          display: flex;
          flex-direction: column;
          gap: 8px;

          .header-even-value {
            font-size: 12px;
            height: 17px;
            line-height: 17px;
          }

          .header-even-key {
            font-size: 14px;
          }
        }
      }

      .right {
        display: flex;
        align-items: center;
        width: 280px;
        justify-content: right;
        gap: 40px;

        .certificateItem {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
        }
      }
    }

    .stranger-center {
      margin-top: 10px;
      min-height: 600px;
      .nav-tab {
        margin-bottom: 0;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        border-bottom-style: solid;
        border-bottom-width: 1px;
      }
      .tables {
        width: 100%;
        // float: left;
      }
    }

    .dialog-p {
      font-size: 14px;
    }

    .payments-ul {
      width: 100%;
      ul {
        display: flex;
        align-items: center;
        gap: 10px;

        li {
          float: right;
          width: 24px;
          height: 24px;
          border-radius: 2px;
          img {
            width: 16px;
            height: 16px;
            margin: 4px;
          }
        }
      }
    }

    .table-head {
      padding: 0;
    }

    .table-body td .icon-btn {
      margin-left: 0;
    }
  }
}
</style>
